import i18n from 'i18next';

import { SelectOptionProps } from '@/types/CommonTypes';

export const getSpeechDurationOptions = (): SelectOptionProps[] => [
  { value: 'Very Short (1–2 minutes)', label: i18n.t('speechDurationVeryShort', { ns: 'common' }) },
  { value: 'Short (3–4 minutes)', label: i18n.t('speechDurationShort', { ns: 'common' }) },
  { value: 'Medium (5–7 minutes)', label: i18n.t('speechDurationMedium', { ns: 'common' }) },
  { value: 'Long (8–10 minutes)', label: i18n.t('speechDurationLong', { ns: 'common' }) },
  { value: 'Extended (10+ minutes)', label: i18n.t('speechDurationExtended', { ns: 'common' }) }
];

export const getRelationshipOptions = (): SelectOptionProps[] => [
  { value: 'Parent', label: i18n.t('relationshipParent', { ns: 'common' }) },
  { value: 'Child', label: i18n.t('relationshipChild', { ns: 'common' }) },
  { value: 'Sibling', label: i18n.t('relationshipSibling', { ns: 'common' }) },
  { value: 'Partner', label: i18n.t('relationshipPartner', { ns: 'common' }) },
  { value: 'Friend', label: i18n.t('relationshipFriend', { ns: 'common' }) },
  { value: 'Colleague', label: i18n.t('relationshipColleague', { ns: 'common' }) },
  { value: 'Other Relative', label: i18n.t('relationshipOtherRelative', { ns: 'common' }) }
];
